export type NewsroomDetailLocationState = {
  /** 상세 진입 직전 화면 경로 (예: /, /newsroom, /admin/newsroom) */
  from?: string;
};

export const NEWSROOM_RETURN = {
  home: "/",
  newsroom: "/newsroom",
  adminNewsroom: "/admin/newsroom",
} as const;

export function getNewsroomReturnTo(state: unknown): string | undefined {
  if (!state || typeof state !== "object" || !("from" in state)) return undefined;
  const from = (state as NewsroomDetailLocationState).from;
  return typeof from === "string" && from.startsWith("/") ? from : undefined;
}

export function newsroomDetailState(from: string): NewsroomDetailLocationState {
  return { from };
}
